import AddIcon from './svgs/AddIcon';
import AnnouncementIcon from './svgs/AnnouncementIcon';
import ArrowRightIcon from './svgs/ArrowRightIcon';
import ArrowLeftIcon from './svgs/ArrowLeftIcon';
import BellIcon from './svgs/BellIcon';
import BugIcon from './svgs/BugIcon';
import CaretDoubleIcon from './svgs/CaretDoubleIcon';
import CaretIcon from './svgs/CaretIcon';
import CheckmarkIcon from './svgs/CheckmarkIcon';
import CheckmarkMixedIcon from './svgs/CheckmarkMixedIcon';
import CircleIcon from './svgs/CircleIcon';
import CircleCompleteIcon from './svgs/CircleCompleteIcon';
import CircleExclamationIcon from './svgs/CircleExclamationIcon';
import CircleInfoIcon from './svgs/CircleInfoIcon';
import CircleOutlineIcon from './svgs/CircleOutlineIcon';
import CircleWarnIcon from './svgs/CircleWarnIcon';
import ClockIcon from './svgs/ClockIcon';
import CloseSmallIcon from './svgs/CloseSmallIcon';
import CloseIcon from './svgs/CloseIcon';
import ConnectBothIcon from './svgs/ConnectBothIcon';
import ConnectPullIcon from './svgs/ConnectPullIcon';
import ConnectPushIcon from './svgs/ConnectPushIcon';
import DashIcon from './svgs/DashIcon';
import DocIcon from './svgs/DocIcon';
import DotsIcon from './svgs/DotsIcon';
import DownloadIcon from './svgs/DownloadIcon';
import DragIcon from './svgs/DragIcon';
import EnvironmentBadgeDevIcon from './svgs/EnvironmentBadgeDevIcon';
import EnvironmentBadgePrdIcon from './svgs/EnvironmentBadgePrdIcon';
import EnvironmentBadgeStgIcon from './svgs/EnvironmentBadgeStgIcon';
import ExclamationIcon from './svgs/ExclamationIcon';
import ExternalLinkIcon from './svgs/ExternalLinkIcon';
import EyeIcon from './svgs/EyeIcon';
import FileAddedIcon from './svgs/FileAddedIcon';
import FileFolderClosedIcon from './svgs/FileFolderClosedIcon';
import FileFolderOpenedIcon from './svgs/FileFolderOpenedIcon';
import FileLeftArrowIcon from './svgs/FileLeftArrowIcon';
import FileLockedIcon from './svgs/FileLockedIcon';
import FileRightArrowIcon from './svgs/FileRightArrowIcon';
import FileUnlockedIcon from './svgs/FileUnlockedIcon';
import GearIcon from './svgs/GearIcon';
import PlayIcon from './svgs/PlayIcon';
import PushIcon from './svgs/PushIcon';
import OfflineIcon from './svgs/OfflineIcon';
import RefreshIcon from './svgs/RefreshIcon';
import SearchIcon from './svgs/SearchIcon';
import SiteShellIcon from './svgs/SiteShellIcon';
import SpinnerIcon from './svgs/SpinnerIcon';
import StarIcon from './svgs/StarIcon';
import StopIcon from './svgs/StopIcon';
import SuccessIcon from './svgs/SuccessIcon';
import YieldIcon from './svgs/YieldIcon';
import WPIcon from './svgs/WPIcon';
import VSIcon from './svgs/VSIcon';

/**
 * Namespace of Icons that can be imported once and reference multiple icons: `Icons.Add`.
 * Note: the name of the exported const should match the filename with the `Icon` suffix removed.
 */
namespace Icons {
	export const Add = AddIcon;
	export const Announcement = AnnouncementIcon;
	export const ArrowRight = ArrowRightIcon;
	export const ArrowLeft = ArrowLeftIcon;
	export const Bell = BellIcon;
	export const Bug = BugIcon;
	export const CaretDouble = CaretDoubleIcon;
	export const Caret = CaretIcon;
	export const Checkmark = CheckmarkIcon;
	export const CheckmarkMixed = CheckmarkMixedIcon;
	export const Circle = CircleIcon;
	export const CircleComplete = CircleCompleteIcon;
	export const CircleExclamation = CircleExclamationIcon;
	export const CircleInfo = CircleInfoIcon;
	export const CircleOutline = CircleOutlineIcon;
	export const CircleWarn = CircleWarnIcon;
	export const Clock = ClockIcon;
	export const Close = CloseIcon;
	export const CloseSmall = CloseSmallIcon;
	export const ConnectBoth = ConnectBothIcon;
	export const ConnectPull = ConnectPullIcon;
	export const ConnectPush = ConnectPushIcon;
	export const Dash = DashIcon;
	export const Doc = DocIcon;
	export const Dots = DotsIcon;
	export const Download = DownloadIcon;
	export const Drag = DragIcon;
	export const EnvironmentBadgeDev = EnvironmentBadgeDevIcon;
	export const EnvironmentBadgePrd = EnvironmentBadgePrdIcon;
	export const EnvironmentBadgeStg = EnvironmentBadgeStgIcon;
	export const Exclamation = ExclamationIcon;
	export const ExternalLink = ExternalLinkIcon;
	export const Eye = EyeIcon;
	export const FileAdded = FileAddedIcon;
	export const FileFolderClosed = FileFolderClosedIcon;
	export const FileFolderOpened = FileFolderOpenedIcon;
	export const FileLeftArrow = FileLeftArrowIcon;
	export const FileLocked = FileLockedIcon;
	export const FileRightArrow = FileRightArrowIcon;
	export const FileUnlocked = FileUnlockedIcon;
	export const Gear = GearIcon;
	export const Offline = OfflineIcon;
	export const Play = PlayIcon;
	export const Push = PushIcon;
	export const Refresh = RefreshIcon;
	export const Search = SearchIcon;
	export const SiteShell = SiteShellIcon;
	export const Spinner = SpinnerIcon;
	export const Stars = StarIcon;
	export const Stop = StopIcon;
	export const Success = SuccessIcon;
	export const VS = VSIcon;
	export const Yield = YieldIcon;
	export const WP = WPIcon;
}

/**
 * Individually exported icons.
 * Note: the name of the exported component should include the `Icon` suffix.
 */
export {
	Icons, // export the namespace 'Icons' here
	AddIcon,
	AnnouncementIcon,
	ArrowRightIcon,
	ArrowLeftIcon,
	BellIcon,
	BugIcon,
	CaretDoubleIcon,
	CaretIcon,
	CheckmarkIcon,
	CheckmarkMixedIcon,
	CircleIcon,
	CircleCompleteIcon,
	CircleExclamationIcon,
	CircleInfoIcon,
	CircleOutlineIcon,
	CircleWarnIcon,
	ClockIcon,
	CloseIcon,
	CloseSmallIcon,
	ConnectBothIcon,
	ConnectPullIcon,
	ConnectPushIcon,
	DashIcon,
	DocIcon,
	DotsIcon,
	DownloadIcon,
	DragIcon,
	EnvironmentBadgeDevIcon,
	EnvironmentBadgePrdIcon,
	EnvironmentBadgeStgIcon,
	ExclamationIcon,
	ExternalLinkIcon,
	EyeIcon,
	FileAddedIcon,
	FileFolderClosedIcon,
	FileFolderOpenedIcon,
	FileLeftArrowIcon,
	FileLockedIcon,
	FileRightArrowIcon,
	FileUnlockedIcon,
	GearIcon,
	OfflineIcon,
	PlayIcon,
	PushIcon,
	RefreshIcon,
	SearchIcon,
	SiteShellIcon,
	SpinnerIcon,
	StarIcon,
	StopIcon,
	SuccessIcon,
	VSIcon,
	YieldIcon,
	WPIcon,
};
